import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Checkbox, FormControlLabel } from "@oriola-origo/origo-ui-core";
import Box from "@oriola-origo/core/lib/Box";
import { CaseType } from "../../../../constants/caseType";
import FieldTitle from "../fieldTitle/fieldTitle";
// eslint-disable-next-line import/no-cycle
import { useStyles } from "../informationConfirmation/informationConfirmation";

interface ConcernHospitalTendersCheckBoxProps {
  disabled?: boolean;
  itemData: {
    uuid: string;
    concernHospitalTenders?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
  fieldsConfig: {
    reasonForRefund: string;
  };
  customerGroup: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateItem: (item: any) => void;
}

export const PHARMACY_FINLAND_OR_MEDICINE_CENTER = ["B4", "B5"];
function ConcernHospitalTendersCheckBox(
  props: Readonly<ConcernHospitalTendersCheckBoxProps>
) {
  const { disabled, itemData, updateItem, fieldsConfig, customerGroup } = props;
  const classes = useStyles();
  const {
    productReturn,
    caseType,
    sourceReclamationId,
    // @ts-expect-error expected-error
  } = useSelector(state => state.case.case);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  if (
    !fieldsConfig.reasonForRefund ||
    !PHARMACY_FINLAND_OR_MEDICINE_CENTER.includes(customerGroup) ||
    !productReturn ||
    sourceReclamationId ||
    caseType !== CaseType.PRODUCT_DELIVERY
  ) {
    return null;
  }

  const handleCheckBox = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    const { name } = e.target;

    dispatch(
      updateItem({
        ...itemData,
        [name]: value,
      })
    );
  };

  return (
    <Box width="100%" mt={2}>
      <FieldTitle title={t("caseItemFields.concernHospitalTenders")} />
      <FormControlLabel
        className={classes.checkboxContainer}
        control={
          <Checkbox
            onChange={handleCheckBox}
            name="concernHospitalTenders"
            checked={itemData?.concernHospitalTenders}
          />
        }
        id="new-case-confirm"
        disabled={disabled}
        label={t("caseItemFields.concernHospitalTendersLabel")}
      />
    </Box>
  );
}

export default ConcernHospitalTendersCheckBox;
